const VERSION_PATTERN = /^\d{2}\.\d{2}\.\d{2}$/;

const PLATFORMS = ["ios", "android"];

/**
 * Blank clears the gate. One filled field and one empty is invalid.
 * Returns the API body, or null when a platform is half filled or malformed.
 */
export const readMinSupportedBuild = (draft) => {
  const body = {};
  for (const key of PLATFORMS) {
    const version = String(draft?.[key]?.version ?? "").trim();
    const buildRaw = String(draft?.[key]?.build ?? "").trim();
    if (!version && !buildRaw) {
      body[key] = null;
      continue;
    }
    const build = Number(buildRaw);
    if (!VERSION_PATTERN.test(version) || !Number.isInteger(build) || build < 1) {
      return null;
    }
    body[key] = { version, build };
  }
  return body;
};
